
export enum AppStep {
  Upload = 'UPLOAD',
  Analyzing = 'ANALYZING',
  Result = 'RESULT',
}

export interface PersonalDetails {
  name: string;
  email: string;
  phone: string;
  linkedin: string;
  location: string;
}

export interface WorkExperience {
  jobTitle: string;
  company: string;
  location: string;
  startDate: string;
  endDate: string;
  responsibilities: string[];
}

export interface Education {
  degree: string;
  institution: string;
  location: string;
  graduationDate: string;
}

export interface OptimizedResume {
  personalDetails: PersonalDetails;
  professionalSummary: string;
  workExperience: WorkExperience[];
  education: Education[];
  skills: string[];
}

export interface AnalysisSuggestion {
  type: 'ATS' | 'Wording' | 'Cultural' | 'General';
  suggestion: string;
  severity: 'High' | 'Medium' | 'Low';
}

export interface GeminiAnalysisResponse {
  analysis: AnalysisSuggestion[];
  optimizedResume: OptimizedResume;
}

export const emptyResume: OptimizedResume = {
    personalDetails: {
        name: "",
        email: "",
        phone: "",
        linkedin: "",
        location: ""
    },
    professionalSummary: "",
    workExperience: [],
    education: [],
    skills: []
};
